<template>
  <div>
    <div class="row" style="margin-top:10px">
      <div class="col col-md-8 offset-md-2 col-sm-12 text-center">
        
        <div class="rowLista">
          <div
            class="list-group-item list-group-item-action"
            v-for="item in itens"
            :key="item.id"
            :item="item"
          >
            <div class="row">
              <div class="col col-md-12">
                <a
                  @click="$emit('selecionar', item._id)"
                  role="button"
                >
                  <div>
                    <h6 style="margin-bottom: 0px!important;">{{ formatDateTime(item.data) }}</h6>
                  </div>
                  <div style="display:none">
                    <p class="text-secondary textoResumo d-flex w-100 justify-content-between">
                      <small>{{ item.usuarioObjeto[0].nome }}</small>
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

export default {
  name: "ListComissoes",
  components: { },
  props: { itensLimit: { type: Number, default: 50 } },
  methods: {
    retornaSite()
    {
      return this.$site;
    },
    async carregarItens() {
      var filtros = "";

      const response = await api.get("/comissao" + filtros);
      api.valid(response.data, this.$router);

      this.itens = response.data.itens;
      
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    formatDateTime(data) {
      return util.formatDateTime(data);
    },
  },
  mounted() {
    this.carregarItens();
  },
  data: function () {
    return {
      filtroTexto: "",
      itens: [],
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}

.inputPesquisa {
  max-width: 50%;
}

.botaoNovo {
  margin-top: 6px;
}
</style>
